module.exports = __webpack_public_path__ + "images/emoji/hammer.4c1299898fd794d4bec6.png";